const AUTH_TOKEN_COOKIE_KEY = 'authKey'
const PRODUCT_INTEGRATION_TYPE = 'ProductIntegration'
const STOCK_INTEGRATION_TYPE = 'StockIntegration'
const PRICE_INTEGRATION_TYPE = 'PriceIntegration'
const ORDER_INTEGRATION_TYPE = 'OrderIntegration'
const ECOMMERCE_INTEGRATION_TYPE = 'ECommerceIntegration'
const ERP_INTEGRATION_TYPE = 'ERPIntegrations'

export {
  AUTH_TOKEN_COOKIE_KEY,
  PRODUCT_INTEGRATION_TYPE,
  STOCK_INTEGRATION_TYPE,
  PRICE_INTEGRATION_TYPE,
  ORDER_INTEGRATION_TYPE,
  ECOMMERCE_INTEGRATION_TYPE,
  ERP_INTEGRATION_TYPE,
}
